var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"inline-submenu-btn with_icon",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('b-icon',{attrs:{"icon":"arrow-left-circle","aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t("retour")))],1)}
var staticRenderFns = []

export { render, staticRenderFns }